import React from 'react';
//Material-ui
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import CreditCard from '@material-ui/icons/CreditCard';
import RemoveIcon from '@material-ui/icons/RemoveCircle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

function Tags({ handleRemove, handleTag, setTag, tag, tags }) {
  return (
    <Paper className="general-paper">
      <Typography variant="body1">Tags Registrados</Typography>
      <Grid container>
        <Grid item xs={12} sm={12}>
          <Grid container alignItems="flex-end">
            <Grid item>
              <IconButton disabled aria-label="Agregar Tag">
                <CreditCard />
              </IconButton>
            </Grid>
            <Grid item>
              <TextField
                label="Número de Tag"
                margin="normal"
                onChange={(e) => setTag(e.target.value)}
                onKeyDown={(e) => (e.key === 'Enter' ? handleTag() : false)}
                value={tag}
              />
            </Grid>
            <Grid item>
              <Button color="secondary" onClick={handleTag}>
                REGISTRAR
              </Button>
            </Grid>
          </Grid>
        </Grid>
        {tags.length > 0 ? (
          <Grid item xs={12}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left">Tag</TableCell>
                  <TableCell align="right">Eliminar</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tags.map((tag, i) => {
                  return (
                    <TableRow key={i}>
                      <TableCell align="left">
                        {
                          <div>
                            <Typography variant="caption">{tag}</Typography>
                          </div>
                        }
                      </TableCell>
                      <TableCell
                        align="right"
                        onClick={() => handleRemove(i, 'tags')}
                      >
                        <IconButton aria-label="Borrar teléfono">
                          <RemoveIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
        ) : null}
      </Grid>
    </Paper>
  );
}

export default Tags;
